export default new class Tab {
    constructor() {
        this.sChangeTabSelectClass = '_change_tab_about_us_select';
        this.sChangeTabButtonClass = '_change_tab_about_us_button';

        this.sActiveTabDesktopClass = 'border-indigo-500 text-indigo-600';
        this.sNotActiveTabDesktopClass = 'border-transparent text-gray-500 hover:text-indigo-600 hover:border-transparent';

        this.sActiveSvgDesktopClass = 'text-indigo-500 mr-2 h-5 w-5';
        this.sNotActiveSvgDesktopClass = 'text-gray-400 group-hover:text-indigo-400 mr-2 h-5 w-5';

        this.sTabDesktopClass = '_tab_desktop';

        this.sContentClass = '_tab_content';

        this.sTabWrapperClass = '_tab-about-us-wrapper';

        this.sActiveContentClass = 'active';

        this.click();
        this.change();
        this.processingSvg();
    }

    processingSvg() {
        const obTabWrapper = $(`.${this.sTabWrapperClass}`);

        obTabWrapper.find('svg').first().addClass(this.sActiveSvgDesktopClass).addClass(this.sChangeTabButtonClass);
        obTabWrapper.find('svg:not(:first)').addClass(this.sNotActiveSvgDesktopClass).addClass(this.sChangeTabButtonClass);
    }

    click() {
        $(document).on('click', `.${this.sChangeTabButtonClass}`, (obEvent) => {
            event.preventDefault();

            let obButton = $(obEvent.target);
            let iTabId = obButton.attr('data-value');
            if (iTabId === undefined) {
                obButton = obButton.closest('a');
                iTabId = obButton.attr('data-value');
            }

            const obTabList = $(`.${this.sTabDesktopClass}`);
            const obSvgList = $(`.${this.sTabWrapperClass}`).find('svg');
            const obSvg = obButton.find('svg');

            obTabList.removeClass(this.sActiveTabDesktopClass);
            obTabList.removeClass(this.sNotActiveTabDesktopClass);
            obTabList.addClass(this.sNotActiveTabDesktopClass);

            obSvgList.removeClass(this.sActiveSvgDesktopClass);
            obSvgList.removeClass(this.sNotActiveSvgDesktopClass);
            obSvgList.addClass(this.sNotActiveSvgDesktopClass);

            obButton.addClass(this.sActiveTabDesktopClass);
            obButton.removeClass(this.sNotActiveTabDesktopClass);

            obSvg.removeClass(this.sNotActiveSvgDesktopClass);
            obSvg.addClass(this.sActiveSvgDesktopClass);

            $(`.${this.sContentClass}`).removeClass(this.sActiveContentClass);
            $(`[data-tab=${iTabId}]`).addClass(this.sActiveContentClass);

        });
    }

    change() {
        $(document).on('change', `.${this.sChangeTabSelectClass}`, (obEvent) => {
            const obSelect = $(obEvent.target);
            const iTabId = obSelect.val();

            $(`.${this.sContentClass}`).removeClass(this.sActiveContentClass);
            $(`[data-tab=${iTabId}]`).addClass(this.sActiveContentClass);
        });
    }
}();
